var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataInteraction.tipo === 'GOOGLE_PUBLISHER_TAG')?_c('app-interaction-ads-gpt',{attrs:{"data-mode":_vm.dataMode,"data-interaction":_vm.dataInteraction}}):(_vm.dataInteraction.tipo === 'VAST')?_c('app-interaction-ads-vast',{attrs:{"data-mode":_vm.dataMode,"data-interaction":_vm.dataInteraction}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }